import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";


function Header() {
    const [navOpen, setNavOpen] = useState(false);
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState('unkknowne')

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setUserInfo(JSON.parse(storedUser));
        }
    }, []);

    const toggleNav = () => {
        setNavOpen(!navOpen);
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate("/", { replace: true });
    }
    return (
        <>
            <div className="header">
                <div className="container">
                    <div className="inn d-flex align-items-center justify-content-between">
                        <h6>Welcome, {userInfo?.name}</h6>
                        <div className="rt-side d-flex align-items-center gap-4">


                            <div className={`navigation ${navOpen ? "open" : ""}`}>
                                <button onClick={toggleNav} className="d-block d-lg-none close_icon">
                                    <i className="fa-solid fa-x"></i>
                                </button>
                                <ul >
                                    {userInfo?.role === "OPERATION" && (
                                        <>
                                            <li><Link to="/operation-dashboard" onClick={toggleNav}>Dashboard</Link></li>
                                            <li><Link to="/master-page" onClick={toggleNav}>Master</Link></li>
                                            <li><Link to="/operation-task" onClick={toggleNav}>Create Task</Link></li>
                                            <li><Link to="/slot-master" onClick={toggleNav}>Manage Slot</Link></li>
                                        </>
                                    )}

                                    {userInfo?.role === "LOGISTIC" && (
                                        <>
                                            <li><Link to="/logistics-dashboard" onClick={toggleNav}>Dashboard</Link></li>
                                            <li><Link to="/logistics-task" onClick={toggleNav}>Tasks</Link></li>
                                            <li><Link to="/logistics-location" onClick={toggleNav}>Client 📍</Link></li>
                                        </>
                                    )}

                                    {userInfo?.role === "CLIENT" && (
                                        <>
                                            <li><Link to="/client-dashboard" onClick={toggleNav}>Dashboard</Link></li>
                                            <li><Link to="/client-task" onClick={toggleNav}>Tasks</Link></li>
                                        </>
                                    )}
                                </ul>
                            </div>

                            <button className='menu-icon d-block d-lg-none' onClick={toggleNav}><i class="fa-solid fa-bars-staggered"></i></button>
                            <div className="logout">
                                <button className='cmn-button' onClick={logout}><i class="fa-solid fa-right-from-bracket"></i> Logout</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header